<div class="container">
  <header><br>
      <!-- <div >
          <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Home</a></li>
                
              </ol>
            </nav>
         </div> -->
  </header>
<div class="col-md-12 box main-text">
    <!-- <div class="cross">+</div> -->
    <br>
    <img src="/assets/board_logo.png" class="img" width="200px" height="200px">
    <!-- <img src="/assets/board_logo.png" class="img" width="300px" height="200px"> -->
    <h1>Goa Board of Secondary and
      Higher Secondary Education
      </h1>
      <h4>Alto Betim -Goa 403 521</h4>

  <!-- <div class="text-box">
      <button  type="button" class="btn btn-warning" [routerLink]="['/home']" style="margin-left: -43px;"><b>Get Result</b></button>
  </div> -->
  <button type="button" class="btn btn-dark button getresult" [routerLink]="['/home']">Get Result</button>
  
  
  <div style="margin-top: 1rem;"><a href='https://results.gbshsegoa.net/previous_result/'><button type="button" class="btn btn-dark button getresult">Get Previous Results</button></a></div>
</div>
</div>
